import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <h1>Политика обработки персональных данных</h1>
          <p className="last-updated">Последнее обновление: 04.05.2026</p>
        </div>

        <div className="privacy-policy-content">
          <section className="policy-section">
            <h2>1. Общие положения</h2>
            <p>
              Настоящая политика обработки персональных данных составлена в соответствии с требованиями 
              Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) 
              и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, 
              предпринимаемые Куставиновой Дарьей, самозанятой (далее — Оператор).
            </p>
            <p>
              Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и свобод 
              человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, 
              личную и семейную тайну.
            </p>
            <p>
              Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется ко всей информации, 
              которую Оператор может получить о посетителях веб-сайта <a href="/">https://dashacakes.store/</a>.
            </p>
          </section>

          <section className="policy-section">
            <h2>2. Основные понятия, используемые в Политике</h2>
            <ul>
              <li><strong>Автоматизированная обработка персональных данных</strong> — обработка персональных данных с помощью средств вычислительной техники.</li>
              <li><strong>Блокирование персональных данных</strong> — временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных).</li>
              <li><strong>Веб-сайт</strong> — совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу <a href="/">https://dashacakes.store/</a>.</li>
              <li><strong>Информационная система персональных данных</strong> — совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств.</li>
              <li><strong>Обезличивание персональных данных</strong> — действия, в результате которых невозможно определить без использования дополнительной информации принадлежность персональных данных конкретному Пользователю.</li>
              <li><strong>Обработка персональных данных</strong> — любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных.</li>
              <li><strong>Оператор</strong> — Куставинова Дарья, самозанятая, самостоятельно или совместно с другими лицами организующая и (или) осуществляющая обработку персональных данных, а также определяющая цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.</li>
              <li><strong>Персональные данные</strong> — любая информация, относящаяся прямо или косвенно к определенному или определяемому Пользователю веб-сайта.</li>
              <li><strong>Пользователь</strong> — любой посетитель веб-сайта.</li>
              <li><strong>Предоставление персональных данных</strong> — действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц.</li>
              <li><strong>Распространение персональных данных</strong> — любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом.</li>
              <li><strong>Трансграничная передача персональных данных</strong> — передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу.</li>
              <li><strong>Уничтожение персональных данных</strong> — любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и (или) уничтожаются материальные носители персональных данных.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>3. Оператор может обрабатывать следующие персональные данные Пользователя</h2>
            
            <h3>3.1. При оформлении заказа:</h3>
            <ul>
              <li>Фамилия, имя, отчество Пользователя;</li>
              <li>Номер телефона Пользователя;</li>
              <li>Адрес доставки заказа (при необходимости);</li>
              <li>Детали заказа (состав, вес, оформление торта).</li>
            </ul>

            <h3>3.2. При оставлении отзыва:</h3>
            <ul>
              <li>Имя Пользователя;</li>
              <li>Текст отзыва;</li>
              <li>Дата и время оставления отзыва.</li>
            </ul>

            <h3>3.3. Технические данные:</h3>
            <ul>
              <li>Данные об использовании файлов cookie;</li>
              <li>Информация о браузере и устройстве;</li>
              <li>Источник перехода на сайт;</li>
              <li>Данные, собираемые Яндекс.Метрикой.</li>
            </ul>

            <p>
              Также на сайте происходит сбор и обработка обезличенных данных о посетителях (в т.ч. файлов cookie) 
              с помощью сервисов интернет-статистики (Яндекс.Метрика).
            </p>
          </section>

          <section className="policy-section">
            <h2>4. Цели обработки персональных данных</h2>
            
            <h3>4.1. Цели обработки персональных данных Пользователя:</h3>
            <ul>
              <li>Предоставление Пользователю доступа к сервисам, информации и/или материалам, содержащимся на веб-сайте;</li>
              <li>Обработка и выполнение заказов на изготовление кондитерских изделий;</li>
              <li>Связь с Пользователем в случае необходимости уточнения деталей заказа;</li>
              <li>Информирование Пользователя о статусе заказа;</li>
              <li>Публикация отзывов Пользователей на сайте (с указанием имени);</li>
              <li>Улучшение качества обслуживания и оптимизация работы сайта;</li>
              <li>Проведение статистических и иных исследований на основе обезличенных данных.</li>
            </ul>

            <h3>4.2. Также Оператор имеет право:</h3>
            <ul>
              <li>Направлять Пользователю уведомления о новых продуктах, специальных предложениях и различных событиях (только с согласия Пользователя);</li>
              <li>Предоставлять данные Пользователя третьим лицам (службам доставки) исключительно в целях выполнения заказа.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>5. Правовые основания обработки персональных данных</h2>
            <p>
              Оператор обрабатывает персональные данные Пользователя только в случае их заполнения и/или отправки Пользователем 
              самостоятельно через специальные формы, расположенные на сайте. Заполняя соответствующие формы и/или отправляя 
              свои персональные данные Оператору, Пользователь выражает своё согласие с данной Политикой путём проставления отметки 
              в соответствующем чекбоксе при заполнении форм на сайте либо иным явным действием, подтверждающим волеизъявление.
            </p>
            <p>
              Оператор обрабатывает обезличенные данные о Пользователе в случае, если это разрешено в настройках браузера 
              Пользователя (включено сохранение файлов cookie и использование технологии JavaScript).
            </p>
          </section>

          <section className="policy-section">
            <h2>6. Порядок сбора, хранения, передачи и других видов обработки персональных данных</h2>
            <p>
              Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, 
              организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства 
              в области защиты персональных данных.
            </p>
            
            <h3>6.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных лиц.</h3>
            
            <h3>6.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства либо если Пользователь выразил согласие на передачу данных.</h3>
            
            <h3>6.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления уведомления Оператору на адрес электронной почты.</h3>
            
            <h3>6.4. Срок обработки персональных данных определяется необходимостью достижения целей, указанных в п. 4.1 настоящей Политики, и не превышает срок, необходимый для их реализации. Пользователь может в любой момент отозвать своё согласие на обработку персональных данных, направив Оператору уведомление по электронной почте.</h3>
          </section>

          <section className="policy-section">
            <h2>7. Использование файлов cookie и Яндекс.Метрики</h2>
            
            <h3>7.1. Файлы cookie</h3>
            <p>
              Сайт использует файлы cookie — небольшие текстовые файлы, сохраняемые на устройстве Пользователя. 
              Cookie позволяют идентифицировать устройство Пользователя при повторных посещениях сайта, что улучшает работу сайта 
              и делает его более удобным для Пользователя.
            </p>
            <p>
              <strong>Типы используемых cookie:</strong>
            </p>
            <ul>
              <li><strong>Необходимые cookie</strong> — обеспечивают корректную работу сайта (оформление заказа, добавление в корзину);</li>
              <li><strong>Аналитические cookie</strong> — используются для сбора статистики о посещениях сайта с помощью Яндекс.Метрики;</li>
              <li><strong>Функциональные cookie</strong> — запоминают предпочтения Пользователя.</li>
            </ul>
            <p>
              Для отказа от использования cookie Пользователь может изменить настройки своего браузера 
              (инструкция: <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">инструкция для Chrome</a>).
            </p>

            <h3>7.2. Яндекс.Метрика</h3>
            <p>
              На сайте используется сервис веб-аналитики Яндекс.Метрика, предоставляемый компанией ООО «ЯНДЕКС». 
              Яндекс.Метрика использует файлы cookie для сбора информации о действиях Пользователей на сайте.
            </p>
            <p>
              <strong>Яндекс.Метрика собирает следующие данные:</strong>
            </p>
            <ul>
              <li>IP-адрес Пользователя;</li>
              <li>Информация о браузере и устройстве;</li>
              <li>Дата и время посещения сайта;</li>
              <li>Просмотренные страницы и действия на сайте;</li>
              <li>Источник перехода на сайт.</li>
            </ul>
            <p>
              Все данные, собираемые Яндекс.Метрикой, являются обезличенными и используются исключительно для анализа 
              посещаемости сайта, улучшения его работы и качества предоставляемых услуг.
            </p>
            <p>
              Для отказа от сбора данных Яндекс.Метрикой Пользователь может установить официальное расширение для блокировки 
              или отключить соответствующие настройки в браузере.
            </p>
          </section>

          <section className="policy-section">
            <h2>8. Трансграничная передача персональных данных</h2>
            <p>
              Оператор не осуществляет трансграничную передачу персональных данных.
            </p>
          </section>

          <section className="policy-section">
            <h2>9. Заключительные положения</h2>
            <p>
              9.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, 
              обратившись к Оператору по электронной почте.
            </p>
            <p>
              9.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. 
              Политика действует бессрочно до замены ее новой версией.
            </p>
            <p>
              9.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу <a href="https://dashacakes.store/policy">https://dashacakes.store/policy</a>.
            </p>
          </section>

          <section className="policy-section">
            <h2>10. Контактная информация</h2>
            <p>
              <strong>Самозанятая:</strong> Куставинова Дарья<br />
              <strong>Email для обращений:</strong> kustavinovadasha@gmail.com<br />
              <strong>Телефон:</strong> +7 (985) 200-37-21<br />+
              <strong>Город:</strong> Чехов, Московская область
            </p>
          </section>

          <div className="policy-actions">
            <button onClick={() => window.history.back()} className="policy-back-btn">
              ← Вернуться на сайт
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;